<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Creating A Unicorn</h1>
                </div>
            </div>
        </div>
    </div>
</section>
<section class>
    <div class="section-lg">
        <div class="container">
         
            <div class="text-justify">
                <p>GHRCACS, Nagpur, hosted an insightful guest lecture on ‘Creating a Unicorn: Building for Scale,’ inspiring students with strategies for rapid business growth. The session provided valuable insights into scaling startups, fostering innovation, and achieving entrepreneurial success in a competitive landscape.</p>
            </div>
            <div class="row mb-20 mt-5">
                <div class="col-md-3 col-6">
                    <div class="gallery-item">
                        <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/unicorin-1.png"
                            data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/unicorin-1.png"
                                alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item">
                        <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/unicorin-2.png"
                            data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/unicorin-2.png"
                                alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item">
                        <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/unicorin-3.png"
                            data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/unicorin-3.png"
                                alt="Events  | Ghrcacsn" title="Events  | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>

            </div>

        </div>
    </div>
</section>
